import { Pipe, PipeTransform } from '@angular/core';
import { DateUtils } from '../utils';
import { DateFormatType } from '../types';

@Pipe({
  name: 'dateFormat',
  standalone: true,
})
export class DateFormatPipe implements PipeTransform {
  transform(value?: string | number, args?: DateFormatType): string {
    return DateUtils.transform(value, args);
  }
}
